/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignPurchaseTaskUpdate = lazyLoad(
  () => import('./index'),
  module => module.AssignPurchaseTaskUpdate
);
